import { AxiosInstance } from 'axios'

import config from '@config'

import { createApiClient } from '@shared/apiClient/createApiClient'

const MAPPED_ENV: Record<string, string> = {
  localhost: config.env,
}

const DEFAULT_ENV = 'partneringone'

const cachedApiClients: Record<string, AxiosInstance> = {}

export default (servicePath: string) => {
  if (cachedApiClients[servicePath]) {
    return cachedApiClients[servicePath]
  }

  const URL_TEMPLATE = `https://api.{env}.p1plus.ponedev.net/${servicePath}`

  const ENV_TO_URL_MAP: Record<string, string> = {
    plus: `https://api.plus.partneringone.informaconnect.com/${servicePath}`,
    partneringone: `https://api.plus.partneringone.informaconnect.com/${servicePath}`,
    green: `https://api.green.prod.p1plus.ponedev.net/${servicePath}`,
    blue: `https://api.blue.prod.p1plus.ponedev.net/${servicePath}`,
    localhost: `http://localhost:8090/${servicePath}`,
  }

  cachedApiClients[servicePath] = createApiClient(MAPPED_ENV, ENV_TO_URL_MAP, DEFAULT_ENV, URL_TEMPLATE)

  return cachedApiClients[servicePath]
}
